import React from "react";
import "./homePage.css";
import Layout from "../../Layout/Layout";
import Banner from "./Banner";
import ServiceList from "./ServiceList";
import MatterialList from "./MatterialList";
import AboutMestry from "./AboutMestry";
import Statistics from "./Statistics";
import TriangleApp from "./TriangleApp";
import BannerQuotes from "./BannerQuotes";
import Testimonial from "./Testimonial";
import JoinNetwork from "./JoinNetwork";

import AboutContent from "./AboutContent";
import ChatSection from "./JoinNetwork";
import SecBanner from "./SecBanner";

const HomePage = () => {
  return (
    <Layout>
      <Banner />
      {/* <SecBanner /> */}

      <ServiceList />

      <MatterialList />

      <AboutContent />
      <TriangleApp />

      <Statistics />
      <Testimonial />
      <JoinNetwork />
    </Layout>
  );
};

export default HomePage;
